<template>
  <div v-loading.fullscreen.lock="pageLoading">
    <div class="header">
      <img id="logo" src="../assets/image/logo.png">
    </div>

    <main v-if="step === 0">
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <br/>
        <img width="100%" src="https://www.changelifesys.com/img/app/81F1B745-C78F-471E-8F8E-3BC3E09A87EE.jpg">
        <br/>
        <br/>
        <el-form ref="form0" :model="form0" :rules="rules0" size="small" :inline="true">
          <el-form-item prop="identityType">
              <el-select
                v-model="form0.identityType"
                placeholder="選擇報名身份"
                @change="onIdentityTypeChange">
                  <el-option
                  v-for="item in identityTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="序號" v-if="form0.showSerialNumberText" prop="SerialNumberText">
              <el-input v-model="SerialNumberText" show-password></el-input>
          </el-form-item>
          <el-form-item style="text-align: center;" v-if="form0.showSerialNumberText">
              <el-button type="primary" style="background: #1a404c;font-size:18px;text-align:center;" @click="checkSerialNumberText">我已繳費</el-button>
          </el-form-item>
          <el-form-item style="text-align: center;" v-if="!form0.showSerialNumberText">
              <el-button type="primary" style="background: #1a404c;font-size:18px;text-align:center;" @click="noneSerialNumberText">下一步</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </main>

    <main v-if="step === 1">
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <div class="desc" v-html="privacy"></div>
        <el-form ref="form1" :model="form1" size="small" :inline="true">
          <el-form-item label="" prop="" style="text-align: center;">
            <el-checkbox v-model="form1.agreeSign">【←點選】我同意簽署</el-checkbox>
          </el-form-item>
          <el-form-item v-if="form1.agreeSign" style="text-align: center;">
            <el-button type="primary" style="background: #1a404c;font-size:18px;text-align:center;" @click="agree">下一步</el-button>
          </el-form-item>
        </el-form>
        <br/>
        <br/>
        <br/>
      </el-col>
    </main>

    <main v-if="step === 2">
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <br>
        <el-form ref="form2" :model="form2" :rules="rules2" size="small" :inline="true">
          <el-form-item label="匯款帳號未5碼" v-if="!form2.showSerialNumberText" prop="account5">
              <el-input v-model="form2.account5"></el-input>
          </el-form-item>
          <el-form-item label="匯款日期" v-if="!form2.showSerialNumberText" prop="remittanceDate">
              <el-date-picker
                v-model="form2.remittanceDate"
                type="date"
                placeholder="請選擇日期"
                value-format="yyyy-MM-dd"
                @change="onRemittanceDateChange">
              </el-date-picker>
          </el-form-item>
          <el-form-item style="text-align: center;" v-if="!form2.showSerialNumberText">
            <el-button type="primary" style="background: #1a404c;font-size:18px;text-align:center;" @click="getMarriageGrowthOuter">我已匯款</el-button>
          </el-form-item>
          <el-form-item style="text-align: center;" v-if="form2.showSerialNumberText">
            <el-button type="primary" style="background: #1a404c;font-size:18px;text-align:center;" @click="getMarriageGrowth">下一步</el-button>
          </el-form-item>
        </el-form>
        <div class="desc" v-html="desc"></div>
      </el-col>
    </main>

    <main v-if="step === 3">
      <div class="title">{{ title }}</div>
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <br>
        <el-form ref="form3" :model="form3" :rules="rules3" size="small" :inline="true">
          <el-form-item label="序號" prop="SerialNumberText">
              <el-input v-model="SerialNumberText" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item v-if="form0.identityType !== 6 && form0.identityType !== 9" prop="groupType">
            <el-select
              v-model="form3.groupType"
              placeholder="選擇組別"
              @change="onGroupTypeChange"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form0.identityType !== 6 && form0.identityType !== 9" prop="districtName">
            <el-select
              v-model="form3.districtName"
              placeholder="選擇牧區"
              @change="onDistrictChange"
            >
              <el-option
                v-for="item in districtOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form0.identityType !== 6 && form0.identityType !== 9" prop="groupId">
            <el-select v-model="form3.groupId" placeholder="選擇小組">
              <el-option
                v-for="item in groupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form0.identityType === 6" label="所屬教會" prop="church">
              <el-input v-model="form3.church"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
              <el-input v-model="form3.name"></el-input>
          </el-form-item>
          <el-form-item v-if="form0.identityType === 7" label="介紹人" prop="introducer">
              <el-input v-model="form3.introducer"></el-input>
          </el-form-item>
          <el-form-item label="電話" prop="phone">
            <el-input v-model="form3.phone"></el-input>
          </el-form-item>
          <el-form-item v-if="form0.identityType === 7" label="Email" prop="email">
            <el-input v-model="form3.email"></el-input>
          </el-form-item>
          <el-form-item label="性別" prop="gender">
            <el-radio v-model="form3.gender" label="男">男</el-radio>
            <el-radio v-model="form3.gender" label="女">女</el-radio>
          </el-form-item>
          <el-form-item label="是否受洗" prop="christianText">
            <el-radio v-model="form3.christianText" label="基督徒">基督徒</el-radio>
            <el-radio v-model="form3.christianText" label="慕道友">慕道友</el-radio>
          </el-form-item>
          <el-form-item label="婚姻狀況" prop="marriageText">
            <el-radio v-model="form3.marriageText" label="單身">單身</el-radio>
            <el-radio v-model="form3.marriageText" label="已婚">已婚</el-radio>
            <el-radio v-model="form3.marriageText" label="其他">其他</el-radio>
          </el-form-item>
          <el-form-item label="備註" prop="memo">
            <el-input
              type="textarea"
              v-model="form3.memo"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item style="text-align: center;">
            <el-button type="primary" style="background: #1a404c;font-size:18px;text-align:center;" @click="onSubmit">完成填寫</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </main>

    <main v-if="step === 6">
      <div class="title">{{ title }}</div>
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <br>
        <el-form ref="form6" :model="form6" :rules="rules6" size="small" :inline="true">
          <el-form-item label="所屬教會" prop="church">
            <el-input v-model="form6.church"></el-input>
          </el-form-item>
          <el-form-item label="負責人" prop="responsible_person">
            <el-input v-model="form6.responsible_person"></el-input>
          </el-form-item>
          <el-form-item label="負責人手機" prop="phone">
            <el-input v-model="form6.phone"></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="email">
            <el-input v-model="form6.email"></el-input>
          </el-form-item>
          <el-form-item label="負責人性別" prop="gender">
            <el-radio v-model="form6.gender" label="男">男</el-radio>
            <el-radio v-model="form6.gender" label="女">女</el-radio>
          </el-form-item>
          <el-form-item label="教會電話" prop="tel">
            <el-input v-model="form6.tel"></el-input>
          </el-form-item>
          <el-form-item label="教會職稱" prop="job_title">
            <el-input v-model="form6.job_title"></el-input>
          </el-form-item>
          <el-form-item label="團體報名人數" prop="registration_number">
            <el-input v-model="form6.registration_number"></el-input>
          </el-form-item>
          <el-form-item label="報名成員姓名(做名牌用)" prop="registration_name_list">
            <el-input
              type="textarea"
              v-model="form6.registration_name_list"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item style="text-align: center;">
            <el-button type="primary" style="background: #1a404c;font-size:18px;text-align:center;" @click="onSubmitOut">完成填寫</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </main>

    <main v-if="step === 4">
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <p v-if="form0.identityType !== 9">小組: {{ successInfo.group_name }}</p>
        <p>姓名: {{ successInfo.name }}</p>
        <div
          class="classInfo"
          style="margin-bottom: 25px;"
        >
          <p>婚姻成長營報名成功</p>
        </div>
      </el-col>
    </main>

    <main v-if="step === 7">
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <p>負責人: {{ successInfo.responsible_person }}</p>
        <p>手機: {{ successInfo.phone }}</p>
        <div
          class="classInfo"
          style="margin-bottom: 25px;"
        >
          <p>婚姻成長營報名成功！我們在7日內確認款項後會寄發簡訊及Mail通知您，謝謝</p>
        </div>
      </el-col>
    </main>

    <main v-if="step === 5">
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <div class="classInfo error">
          <p>{{ errorMessage }}</p>
        </div>
      </el-col>
    </main>
  </div>
</template>

<script>
import {
  getClcGroupSelect,
  getEventDesc,
  getIdentityType,
  checkSerialNumberText,
  getMarriageGrowth,
  getMarriageGrowthOuter,
  sendMarriageGrowth,
  sendMarriageGrowthOuter
} from '../api/marriageGrowth'

export default {
  name: 'MarriageGrowth',
  data () {
    return {
      pageLoading: false,
      step: 0,
      title: '',
      desc: '',
      privacy: '',
      errorMessage: '',
      typeOptions: [],
      districts: [],
      groups: [],
      identityTypes: [],
      memberId: '',
      SerialNumberText: '',
      form0: {
        identityType: '',
        showSerialNumberText: true
      },
      form1: {
        agreeSign: false
      },
      form2: {
        showSerialNumberText: true, // ===form0.SerialNumberText
        account5: '',
        remittanceDate: new Date()
      },
      form3: {
        identity_type: '',
        church: '',
        groupType: '',
        districtName: '',
        groupId: '',
        name: '',
        phone: '',
        email: '',
        gender: '男',
        memo: '',
        introducer: '',
        christianText: '基督徒',
        marriageText: ''
      },
      form6: {
        church: '',
        gender: '男',
        responsible_person: '',
        phone: '',
        tel: '',
        job_title: '',
        registration_number: 0,
        registration_name_list: '',
        title: '',
        email: ''
      },
      rules0: {
        identityType: [
          { required: true, message: '選擇報名身份', trigger: 'change' }
        ]
      },
      rules2: {
        account5: [
          { required: true, message: '請填寫匯款帳號未5碼', trigger: 'blur' }
        ],
        remittanceDate: [
          { required: true, message: '請選擇匯款日期', trigger: 'change' }
        ]
      },
      rules3: {
        groupType: [
          { required: true, message: '請選擇組別', trigger: 'change' }
        ],
        districtName: [
          { required: true, message: '請選擇牧區', trigger: 'change' }
        ],
        groupId: [
          { required: true, message: '請選擇小組', trigger: 'change' }
        ],
        name: [
          { required: true, message: '請填寫姓名', trigger: 'blur' }
        ],
        introducer: [
          { required: true, message: '請填寫介紹人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '請填寫寫電話', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const isValid = /^(09)[0-9]{8}$/.test(value)
              return isValid ? callback() : callback(new Error('手機格式錯誤'))
            },
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: '請填寫mail', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const isValid = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(value)
              return isValid ? callback() : callback(new Error('mail格式錯誤'))
            },
            trigger: 'blur'
          }
        ],
        gender: [
          { required: true, message: '請填寫負責人性別', trigger: 'change' }
        ],
        christianText: [
          { required: true, message: '請填寫是否受洗', trigger: 'change' }
        ],
        marriageText: [
          { required: true, message: '請填寫婚姻狀況', trigger: 'change' }
        ]
      },
      rules6: {
        church: [
          { required: true, message: '請填寫所屬教會', trigger: 'blur' }
        ],
        responsible_person: [
          { required: true, message: '請填寫負責人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '請填寫寫電話', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const isValid = /^(09)[0-9]{8}$/.test(value)
              return isValid ? callback() : callback(new Error('手機格式錯誤'))
            },
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: '請填寫mail', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const isValid = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(value)
              return isValid ? callback() : callback(new Error('mail格式錯誤'))
            },
            trigger: 'blur'
          }
        ],
        gender: [
          { required: true, message: '請填寫負責人性別', trigger: 'change' }
        ],
        tel: [
          { required: true, message: '請填寫教會電話', trigger: 'change' }
        ],
        job_title: [
          { required: true, message: '請填寫教會職稱', trigger: 'change' }
        ],
        registration_number: [
          { required: true, message: '請填寫團體報名人數', trigger: 'change' }
        ],
        registration_name_list: [
          { required: true, message: '請填寫報名成員姓名(做名牌用)', trigger: 'blur' }
        ]
      },
      successInfo: {},
      isUser: false
    }
  },
  computed: {
    districtOptions () {
      const groupMap = this.groups
        .filter(g => g.group_type_name === this.form3.groupType)
        .reduce((acc, g) => {
          acc[g.district_name] = true
          return acc
        }, {})
      return Object.keys(groupMap).map(g => ({ label: g, value: g }))
    },
    groupOptions () {
      return this.groups
        .filter(g => g.district_name === this.form3.districtName)
        .map(g => ({ label: `${g.group_id} ${g.group_name}`, value: g.group_id }))
    }
  },
  created () {
    this.getIdentityType()
    this.getClcGroupSelect()
    location.href = 'https://marriage.changelifechurch.com'
  },
  methods: {
    getIdentityType () {
      getIdentityType()
        .then(({ content }) => {
          this.identityTypes = content.map(d => ({ label: d.text, value: d.value }))
        }).catch(err => {
          console.log(err)
        })
    },
    checkSerialNumberText () {
      this.$refs['form0'].validate((valid) => {
        if (valid) {
          checkSerialNumberText({ SerialNumberText: this.SerialNumberText })
            .then(({ content, success, message }) => {
              if (success) {
                this.getEventDesc()
              } else {
                this.errorMessage = message
                this.step = 5
              }
            }).catch(err => {
              console.log(err)
            })
        } else {
          return false
        }
      })
    },
    noneSerialNumberText () {
      this.getEventDesc()
    },
    agree () {
      this.step = 2
    },
    getEventDesc () {
      getEventDesc({
        belongs_to: this.$route.params.belongsTo,
        clc_form_info: this.$cookie.get('clc_form_info') || '',
        identity_type: this.form0.identityType
      })
        .then(({ content, success, message }) => {
          if (success) {
            this.desc = content.event_desc
            this.privacy = content.privacy_sign_desc
            this.title = content.event_title
            if (content.is_privacy_sign) {
              // 已簽署過隱私權政策
              this.step = 2
            } else {
              this.step = 1
            }
            this.form2.showSerialNumberText = this.form0.showSerialNumberText
            if (!this.form0.showSerialNumberText) {
              getMarriageGrowthOuter({
                belongs_to: this.$route.params.belongsTo,
                clc_form_info: this.$cookie.get('clc_form_outer_info') || '',
                account5: '99999',
                remittanceDate: new Date()
              })
                .then(({ content, success, message }) => {
                  if (success) {
                    this.form2.account5 = content.account5
                    this.form2.remittanceDate = content.remittanceDate
                  }
                }).catch(err => {
                  console.log(err)
                })
            }
          } else {
            this.errorMessage = message
            this.step = 5
          }
        }).catch(err => {
          console.log(err)
        })
    },
    getMarriageGrowth () {
      getMarriageGrowth({
        belongs_to: this.$route.params.belongsTo,
        clc_form_info: this.$cookie.get('clc_form_info') || '',
        SerialNumberText: this.SerialNumberText
      })
        .then(({ content, success, message }) => {
          if (success) {
            this.memberId = content.member_id
            this.form3.groupId = content.group_id
            if (content.group_id) {
              const targetGroup = this.groups.find(group => group.group_id === content.group_id)
              this.form3.groupType = targetGroup.group_type_name
              this.form3.districtName = targetGroup.district_name
              this.form3.groupId = targetGroup.group_id
            }
            this.form3.name = content.name
            this.form3.phone = content.phone
            this.form3.email = content.email
            this.form3.title = content.title
            this.form3.gender = content.gender
            this.form3.identity_type = content.identity_type
            this.form3.memo = content.memo
            this.form3.church = content.church
            this.form3.christianText = content.christianText
            this.form3.marriageText = content.marriageText
            this.step = 3
          } else {
            this.errorMessage = message
            this.step = 5
          }
        }).catch(err => {
          console.log(err)
        })
    },
    getMarriageGrowthOuter () {
      this.$refs['form2'].validate((valid) => {
        if (valid) {
          getMarriageGrowthOuter({
            belongs_to: this.$route.params.belongsTo,
            clc_form_info: this.$cookie.get('clc_form_outer_info') || '',
            account5: this.form2.account5,
            remittanceDate: this.form2.remittanceDate
          })
            .then(({ content, success, message }) => {
              if (success) {
                this.form6.church = content.church
                this.form6.gender = content.gender
                this.form6.responsible_person = content.responsiblePerson
                this.form6.phone = content.phone
                this.form6.tel = content.tel
                this.form6.job_title = content.jobTitle
                this.form6.registration_number = content.registrationNumber
                this.form6.registration_name_list = content.registrationNameList
                this.title = content.title
                this.form6.email = content.email
                this.step = 6
              } else {
                this.errorMessage = message
                this.step = 5
              }
            }).catch(err => {
              console.log(err)
            })
        } else {
          return false
        }
      })
    },
    getClcGroupSelect () {
      getClcGroupSelect()
        .then(({ content }) => {
          this.typeOptions = content.group_type.map(d => ({ label: d, value: d }))
          this.districts = content.district
          this.groups = content.group
        }).catch(err => {
          console.log(err)
        })
    },
    onIdentityTypeChange () {
      console.log(this.form0.identityType)
      if (this.form0.identityType !== 6) {
        // 本堂會友
        this.form0.showSerialNumberText = true
      } else {
        // 非本堂會友
        this.form0.showSerialNumberText = false
      }
    },
    onGroupTypeChange () {
      this.form3.group_id = ''
      this.form3.districtName = ''
    },
    onDistrictChange () {
      this.form3.groupId = ''
    },
    onRemittanceDateChange () {
      console.log(this.form2.remittanceDate)
    },
    onSubmit () {
      console.log(this.form0.identityType)
      this.$refs['form3'].validate((valid) => {
        if (valid) {
          this.pageLoading = true
          const submitData = {
            belongs_to: this.$route.params.belongsTo,
            group_id: this.form3.groupId,
            name: this.form3.name,
            phone: this.form3.phone,
            email: this.form3.email,
            gender: this.form3.gender,
            identity_type: this.form0.identityType,
            memo: this.form3.memo,
            church: this.form3.church,
            is_privacy_sign: this.form0.agreeSign,
            introducer: this.form3.introducer,
            SerialNumberText: this.SerialNumberText,
            christianText: this.form3.christianText,
            marriageText: this.form3.marriageText
          }
          sendMarriageGrowth(submitData)
            .then(({ content, success, message }) => {
              if (!success) {
                this.errorMessage = message
                this.step = 5
              } else {
                this.successInfo = content
                this.step = 4
                let date = new Date()
                date.setDate(date.getDate() + 360)
                this.$cookie.set('clc_form_info', content.clc_form_info, { expires: date })
              }
            })
            .catch(err => {
              console.log('sendMarriageGrowth: ', err)
            })
            .finally(() => {
              this.resetForm()
              this.pageLoading = false
            })
        } else {
          return false
        }
      })
    },
    onSubmitOut () {
      this.$refs['form6'].validate((valid) => {
        if (valid) {
          this.pageLoading = true
          const submitData = {
            belongs_to: this.$route.params.belongsTo,
            is_privacy_sign: this.form0.agreeSign,
            church: this.form6.church,
            gender: this.form6.gender,
            responsible_person: this.form6.responsible_person,
            phone: this.form6.phone,
            tel: this.form6.tel,
            job_title: this.form6.job_title,
            registration_number: this.form6.registration_number,
            registration_name_list: this.form6.registration_name_list,
            account_5: this.form2.account5,
            email: this.form6.email,
            remittance_date: this.form2.remittanceDate
          }
          console.log(submitData)
          sendMarriageGrowthOuter(submitData)
            .then(({ content, success, message }) => {
              if (!success) {
                this.errorMessage = message
                this.step = 5
              } else {
                this.successInfo = content
                this.step = 7
                let date = new Date()
                date.setDate(date.getDate() + 360)
                this.$cookie.set('clc_form_outer_info', content.clc_form_info, { expires: date })
              }
            })
            .catch(err => {
              console.log('sendMarriageGrowthOuter: ', err)
            })
            .finally(() => {
              this.resetFormOuter()
              this.pageLoading = false
            })
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.form = {
        districtName: '',
        groupId: '',
        name: '',
        phone: ''
      }
    },
    resetFormOuter () {
      this.form6 = {
        church: '',
        gender: '男',
        responsible_person: '',
        phone: '',
        tel: '',
        job_title: '',
        registration_number: 0,
        registration_name_list: '',
        account5: '',
        remittanceDate: '',
        title: ''
      }
    }
  }
}
</script>

<style scope>
#logo {
  height: 100%;
}

.header {
  position: relative;
  padding: 5px 0;
  height: 50px;
  background-color: #1c404c;
  user-select: none;
  z-index: 1;
  text-align: center;
}

.desc {
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 12px;
}

.el-select {
  display: block;
}

.el-form--inline .el-form-item {
  display: flex;
  margin-right: 0;
}

.el-form--inline .el-form-item__content {
  flex: 1;
}

.classInfo {
  border: 2px solid #008088;
  background-color: #f2f2f2;
  color: #008088;
  text-align: center;
  margin-top: 1rem;
}

.classInfo.error {
  color: red;
  padding: 1rem;
}

.classInfo.fat {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.title {
  background-color: #008088;
  color: white;
  text-align: center;
  padding: .5em;
}

.buttonBox {
  display: flex;
}

.button {
  flex: 1;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
}

.el-checkbox__input {
    line-height: 1.5;
}

.el-checkbox__label {
  font-size: 22px;
  color: red;
  font-weight:bold;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #008088;
}

.el-checkbox__inner {
  width: 22px;
  height: 22px;
}

.el-checkbox__inner::after {
  border: none;
}

.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #008088;
    border-color: #008088;
}
</style>
